export default function (vm, title, content, variant = 'primary') {
  if (vm) {
    vm.$bvToast.toast(content, {
      title: title,
      toastClass: 'status-success',
      delay: 3000,
      autohide: true,
      appendToast: true,
      variant: variant,
      toaster: 'b-toaster-bottom-left',
      isStatus: true
    })
  }
}
